module.exports = __webpack_public_path__ + "static/media/android.3ec99101.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/skills/android.png
// module id = 72
// module chunks = 0